import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function BremenGo() {
  const ProjectBG = require("../../../../assets/videos/bremen-go/t3.png");
  const T1 = require("../../../../assets/videos/bremen-go/t1.png");
  const T2 = require("../../../../assets/videos/bremen-go/t2.png");
  const T3 = require("../../../../assets/videos/bremen-go/t3.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="BremenGo — your guide to the city center"
      lead={
        <p>
          BremenGo helps visitors discover sights and landmarks with tours,
          maps, rich media, and AR—designed for an inclusive, self-guided
          exploration of Bremen.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/bremen-go/1_Bremen+go.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Discover Bremen&apos;s treasures</WorkSectionHeading>
          <p>
            Immerse yourself in history and culture—from iconic landmarks to
            hidden gems—with an app built to reveal the city&apos;s character.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={T2}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/bremen-go/2_Bremen+go.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Tours</WorkSectionHeading>
          <p>
            Start with the Old Town Tour through the historic center; more tours
            are planned to expand how you explore.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T3}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/bremen-go/3_BremenGo.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Interactive city map</WorkSectionHeading>
          <p>
            See your position, the tour route, and POIs on a live map—follow a
            suggested path or build your own for a seamless visit.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={T3}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/bremen-go/3_BremenGo.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Engaging multimedia</WorkSectionHeading>
          <p>
            At each POI, unlock videos, audio, images, and text that tell the
            story of Bremen&apos;s past and present.
          </p>
          <WorkSectionHeading>Augmented reality</WorkSectionHeading>
          <p>
            Where marked, AR adds panoramas, visualizations, and playful layers
            that blend history with the street in front of you.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <p>
          Free on the App Store and Google Play—join thousands exploring Bremen
          with BremenGo as a trusted companion.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "BremenGo" },
          { label: "Period", value: "01.2023 - 03.2023" },
          { label: "Client", value: "Wirtschaftsförderung Bremen GmbH" },
          { label: "Engine & Tools", value: "Unity, AR Foundation, C#" },
          { label: "Platform", value: "Mobile" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "AR" },
        ]}
      />
    </WorkProjectShell>
  );
}
